module.exports = __webpack_public_path__ + "static/media/15-06.15fd7c76.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/videos/15-06.mp4
// module id = 128
// module chunks = 0